var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-3"},[_c('epi',{key:_vm.$root.$session.versao,attrs:{"intEpiId":this.$route.params.intId,"intTipoEquipamentoId":1342}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }